/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/UserActivityItem'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./UserActivityItem'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.UserActivityReport = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.UserActivityItem);
  }
}(this, function(ApiClient, UserActivityItem) {
  'use strict';




  /**
   * The UserActivityReport model module.
   * @module model/UserActivityReport
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>UserActivityReport</code>.
   * @alias module:model/UserActivityReport
   * @class
   */
  var exports = function() {
    var _this = this;






  };

  /**
   * Constructs a <code>UserActivityReport</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/UserActivityReport} obj Optional instance to populate.
   * @return {module:model/UserActivityReport} The populated <code>UserActivityReport</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('UserActivityItems')) {
        obj['UserActivityItems'] = ApiClient.convertToType(data['UserActivityItems'], [UserActivityItem]);
      }
      if (data.hasOwnProperty('AvgUserActivityStatus')) {
        obj['AvgUserActivityStatus'] = ApiClient.convertToType(data['AvgUserActivityStatus'], 'String');
      }
      if (data.hasOwnProperty('PeriodStartDate')) {
        obj['PeriodStartDate'] = ApiClient.convertToType(data['PeriodStartDate'], 'Date');
      }
      if (data.hasOwnProperty('PeriodEndDate')) {
        obj['PeriodEndDate'] = ApiClient.convertToType(data['PeriodEndDate'], 'Date');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {Array.<module:model/UserActivityItem>} UserActivityItems
   */
  exports.prototype['UserActivityItems'] = undefined;
  /**
   * @member {String} AvgUserActivityStatus
   * @default ''
   */
  exports.prototype['AvgUserActivityStatus'] = '';
  /**
   * @member {Date} PeriodStartDate
   */
  exports.prototype['PeriodStartDate'] = undefined;
  /**
   * @member {Date} PeriodEndDate
   */
  exports.prototype['PeriodEndDate'] = undefined;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


